import React from 'react';
import { Text } from 'react-native';
import { Button, Dialog, Portal, useTheme } from 'react-native-paper';

interface ReleaseJobDialogProps {
  visible: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation dialog for releasing an assigned job back to the pool. Shared by
 * the driver board and a driving supervisor's Job Queue.
 */
const ReleaseJobDialog: React.FC<ReleaseJobDialogProps> = ({
  visible,
  onDismiss,
  onConfirm,
}) => {
  const theme = useTheme();
  return (
    <Portal>
      <Dialog visible={visible} onDismiss={onDismiss}>
        <Dialog.Title>Release Job</Dialog.Title>
        <Dialog.Content>
          <Text style={{ color: theme.colors.onSurface }}>
            Release this job back to the pool?
          </Text>
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={onDismiss}>Cancel</Button>
          <Button testID="release-confirm-button" onPress={onConfirm}>
            Confirm
          </Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
};

export default ReleaseJobDialog;
